import React, { useEffect, useRef, useState } from 'react';
import { Container, Typography, Card, Box, Stack, Grid, CardMedia, Button, IconButton, Skeleton } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import Slider from 'react-slick'; // Import the Slider component from react-slick
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// Import icons from Material-UI Icons
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
// import HeadsetMicTwoToneIcon from '@mui/icons-material/HeadsetMicTwoTone';
import { getAllYoutubeVideos } from '../server/api/youtubeVideos';
import ProductCard from '../segment/Products/productCard';
import NoImage from '../assets/Image/NoImage.png';
// import Youtube from '../segment/@common/Youtube/youtube';
import YoutubeCarousel from '../segment/youtubeCarousal';

// import ProductSingleYoutube from '../segment/@common/productSingleYoutube/ProductSingleYoutube';
import LoadingScreen from '../components/loading/loading-screen';
import { useDevice } from '../hooks/useResponsive';

import { MetaHelmet } from '../layouts/Helmet/Helmet';
import { getRelatedVehicles, getVehicleDetails } from '../server/api/vehicle';
// import SubmitModal from './popup';
import Lead from './lead';
import useCloudinary from '../hooks/useCloudinaryImage';
import EmiBox from './EmiSection';

import ProductSingleYoutubeShort from '../segment/@common/productSingleYoutube/ProductSingleYoutubeShort';
import { getAllCarDelivery } from '../server/api/carDelivery';
import CarDeliverySection from '../segment/carDeliverySection';

export default function ProductSinglePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const leftRef = useRef(null);

  const params = useParams();
  const isMobiles = useDevice();
  const isMobile = isMobiles?.isMobile;

  const { loading, vehicleDetails, relatedVehicles, youtubeVideosList, carDeliveryList } = useSelector((state) => ({
    vehicleDetails: state.vehicle.vehicleDetails,
    relatedVehicles: state.vehicle.relatedVehicles,
    loading: state.vehicle.loading,
    youtubeVideosList: state.YoutubeVideo.youtubeVideos,
    carDeliveryList: state.CarDelivery.deliveries,
  }));

  // console.log('youtubeVideosList>>>>', youtubeVideosList);

  // const filteredVehicles = relatedVehicles?.relatedVehicles?.filter((vehicle) => {
  //   if (!vehicle.isSold) return true; // keep items that are not sold

  //   const soldDate = new Date(vehicle.soldDate);
  //   const limitDate = new Date(soldDate);
  //   limitDate.setDate(soldDate.getDate() + 3);

  //   const today = new Date();

  //   // include if today is still within 3 days after soldDate
  //   return today <= limitDate;
  // });
  // console.log('relatedVehicles', relatedVehicles);

  const [scrollValue, setScrollValue] = useState();
  // const [modal, setModal] = React.useState(false);
  const [openLeadModal, setOpenLeadModal] = React.useState(false);
  const [selectedImage, setSelectedImage] = useState(vehicleDetails?.images?.[0]?.url || '/assets/car.png');
  React.useEffect(() => {
    const handleScroll = () => {
      const scrollValue = window.scrollY;
      setScrollValue(scrollValue);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const credentials = {
      vehicleId: params?.id,
      dispatch,
    };
    dispatch(getVehicleDetails(credentials));
  }, [dispatch, params?.id]);

  useEffect(() => {
    const credentials = {
      vehicleId: params?.id,
      dispatch,
    };
    dispatch(getRelatedVehicles(credentials));
  }, [dispatch, params?.id]);

  // Custom left arrow component
  const CustomPrevArrow = (props) => {
    // eslint-disable-next-line react/prop-types
    const { onClick } = props;
    return (
      <div
        className="arrow arrow-left LeftArrow"
        role="button"
        tabIndex="0"
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onClick();
        }}
      >
        <ChevronLeftIcon /> {/* Use the ChevronLeftIcon from Material-UI Icons */}
      </div>
    );
  };

  // Custom right arrow component
  const CustomNextArrow = (props) => {
    // eslint-disable-next-line react/prop-types
    const { onClick } = props;
    return (
      <div
        className="arrow arrow-right RighrArrow"
        role="button"
        tabIndex="0"
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onClick();
        }}
      >
        <ChevronRightIcon /> {/* Use the ChevronRightIcon from Material-UI Icons */}
      </div>
    );
  };

  // Configuration for the carousel
  const carouselSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 2 : 4.5,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />, // Custom left arrow component
    nextArrow: <CustomNextArrow />, // Custom right arrow component
  };

  const carouselSettings2 = {
    height: 550,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 1.5,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />, // Custom left arrow component
    nextArrow: <CustomNextArrow />, // Custom right arrow component
    customPaging: () => (
      <div
        style={{
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          background: '#D9D9D9',
          margin: '0 2px', // tighter spacing
        }}
      />
    ),
    appendDots: (dots) => (
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '0px', // consistent gap
          paddingTop: '2px',
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        {dots}
      </div>
    ),
  };

  const CustomButton = styled(Button)({
    background: '#F8971C',
    color: '#342C2C',
    borderTopRightRadius: '10px',
    borderBottomRightRadius: '10px',
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',

    boxShadow: '0 10px 10px rgba(0, 0, 0, 0.9)',
    // fontWeight: 'bold',
    '&:hover': {
      background: '#F8971C',
      color: '#342C2C',
    },
  });

  const handleOwnershipStatus = (status) => {
    switch (status) {
      case 'first_owner':
        return 'First';
      case 'second_owner':
        return 'Second';
      case 'third_owner':
        return 'Third';
      default:
        return '';
    }
  };

  const capitalizeFirstLetter = (str) => str?.charAt(0)?.toUpperCase() + str?.slice(1);

  // const handleSubmitLead = () => {
  //   const credentials = {
  //     state: {
  //       leadType: 'buy',
  //       vehicle: vehicleDetails?._id,
  //     },
  //     dispatch,
  //     setModal,
  //   };
  //   dispatch(createLead(credentials));
  // };

  // console.log(isMobile);
  const image = [{ img: '/assets/car.png' }, { img: '/assets/car.png' }];

  const close = () => {
    setOpenLeadModal(false);
  };

  // console.log(vehicleDetails);
  const thumbnailSettings = {
    dots: false,
    infinite: false,
    slidesToShow: 4.8,
    slidesToScroll: 2,
    arrows: false,
  };
  const [imgLoading, setImgLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const newImage = vehicleDetails?.images?.[0]?.url || '/assets/car.png';

    setImgLoading(true); // reset loader
    setSelectedImage(newImage);

    // Preload image in memory
    const img = new Image();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    img.src = useCloudinary(newImage, 'w_800,q_auto,f_auto');

    img.onload = () => {
      if (active) setImgLoading(false);
    };
    img.onerror = () => {
      if (active) setImgLoading(false);
    };

    return () => {
      active = false; // cleanup if unmounted
      setImgLoading(true); // reset for next mount
    };
  }, [vehicleDetails]);

  // console.log('imgLoading', imgLoading);
  useEffect(() => {
    const credentials = {
      page: '',
      search: '',
      limit: '',
      sortBy: '',
      dispatch,
    };
    dispatch(getAllYoutubeVideos(credentials));
  }, [dispatch]);

  useEffect(() => {
    const credentials = {
      page: '',
      search: '',
      limit: '',
      sortBy: '',
      dispatch,
    };
    dispatch(getAllCarDelivery(credentials));
  }, [dispatch]);

  return (
    <>
      <MetaHelmet title={'Product'} companyName={'Focus Motors'} />
      <Lead open={openLeadModal} close={close} setOpenLeadModal={setOpenLeadModal} />
      {/* <SubmitModal open={modal} close={() => setModal(false)} /> */}
      {loading ? (
        <LoadingScreen />
      ) : (
        <>
          {isMobile && (
            <Box
              position="relative"
              sx={{ width: '100%', maxWidth: 500, mx: 'auto', overflowX: 'clip' }}
              className="zeal-product-slide ProductSingle"
            >
              {/* <Slider {...carouselSettings2} style={{ paddingTop: '15px' }}>
                {vehicleDetails?.images?.length === 0 ? (
                  <Stack key="default-image" className="related-prod">
                    <Card className="CardTransform">
                      <CardMedia
                        component="img"
                        className="card-img samesize"
                        src="/assets/car.png"
                        alt="Default Image"
                      />
                    </Card>
                  </Stack>
                ) : (
                  vehicleDetails.images?.map((item, key) => (
                    <Stack key={key} className={!isMobile && 'related-prod'} px={0.3}>
                      <Card className="CardTransform">
                        <CardMedia
                          component="img"
                          className={isMobile ? '' : 'card-img samesize'}
                          // eslint-disable-next-line react-hooks/rules-of-hooks
                          src={item?.url ? useCloudinary(item.url, 'w_800') : '/assets/car.png'}
                          alt="Card Image"
                          sx={{ objectFit: 'cover' }}
                        />
                      </Card>
                    </Stack>
                  ))
                )}
              </Slider> */}
              {loading ? (
                <Stack direction="row" spacing={2} px={0.3}>
                  {[1].map((i) => (
                    <Card key={i} className="CardTransform" sx={{ width: '100%' }}>
                      <Skeleton
                        variant="rectangular"
                        width={isMobile ? '100%' : 280}
                        height={isMobile ? 180 : 220}
                        sx={{ borderRadius: '10px' }}
                      />
                    </Card>
                  ))}
                </Stack>
              ) : (
                <Slider {...carouselSettings2} style={{ paddingTop: '15px' }}>
                  {vehicleDetails?.images?.length === 0 ? (
                    <Stack key="default-image" className="related-prod">
                      <Card className="CardTransform" sx={{ borderRadius: '0px' }}>
                        <CardMedia
                          component="img"
                          className="card-img samesize"
                          src="/assets/car.png"
                          alt="Default Image"
                        />
                      </Card>
                    </Stack>
                  ) : (
                    vehicleDetails.images?.map((item, key) => (
                      <Stack key={key} className={!isMobile && 'related-prod'} px={0.3}>
                        <Card className="CardTransform" sx={{ borderRadius: '0px' }}>
                          <CardMedia
                            component="img"
                            className={isMobile ? '' : 'card-img samesize'}
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            src={item?.url ? useCloudinary(item.url, 'w_500') : '/assets/car.png'}
                            // w_800
                            alt="Card Image"
                            sx={{ objectFit: 'cover', aspectRatio: 4 / 3 }}
                          />
                        </Card>
                      </Stack>
                    ))
                  )}
                </Slider>
              )}

              {/* Back Button */}
              <IconButton
                onClick={() => navigate(-1)}
                //                      onClick={() => {
                //   navigate(-1);
                //   setTimeout(() => {
                //     window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                //   }, 0); // ensures it runs after navigation
                // }}
                sx={{
                  position: 'absolute',
                  top: 16,
                  left: 3,
                  color: '#ffffff',
                  backgroundColor: '#00000099',
                  '&:hover': {
                    backgroundColor: 'rgba(#837c69,0.9)',
                  },
                  zIndex: 2,
                }}
              >
                <ArrowBack sx={{ height: '25px' }} />
              </IconButton>
            </Box>
          )}
          <Box className="bg-color" px={!isMobile && '75px'}>
            <Container
              className="ProductSingle"
              maxWidth="xl"
              my={isMobile && 5}
              px={!isMobile && '0px !important'}
              // px={isMobile&&0}
              sx={{ padding: isMobile ? '0px 18px 0px 18px' : '16px 0px 0px 0px !important' }}
            >
              {/* <Slider {...carouselSettings2}>
            {vehicleDetails?.images?.length === 0 ? (
              <>
                {image?.map((item, key) => (
                  <Card className="CardTransform" key={key}>
                    <CardMedia component="img" className="card-img samesize" src={item?.img} alt="Card Image" />
                  </Card>
                ))}
              </>
            ) : (
              <>
                {vehicleDetails?.images?.map((item, key) => (

                  <Card className="CardTransform" key={key}>
                    <CardMedia
                      component="img"
                      className="card-img samesize"
                      src={item?.url }
                      alt="Card Image"
                    />
                  </Card>
                ))}
              </>
            )}
          </Slider> */}
              <Stack gap={5} direction={isMobile ? 'column' : 'row'}>
                <Stack
                  sx={{
                    ...(!isMobile && {
                      width: '65%',
                      position: 'sticky',
                      top: 0, // 👈 ensures it stays fixed at top while scrolling
                      alignSelf: 'flex-start', // avoids stretching
                      maxHeight: '110vh',
                      overflowY: 'auto',
                    }),
                  }}
                >
                  {!isMobile && (
                    <>
                      <Box sx={{ backgroundColor: '#121212 !important' }}>
                        {/* Main Image */}
                        <Card sx={{ mb: 2, backgroundColor: '#121212', boxShadow: 'unset' }}>
                          {loading || imgLoading ? (
                            <Skeleton
                              variant="rectangular"
                              width="100%"
                              height={isMobile ? 250 : 500}
                              sx={{ borderRadius: '16px', bgcolor: '#1e1e1e' }}
                            />
                          ) : (
                            <Box
                              position="relative"
                              sx={{ width: '100%', mx: 'auto', overflowX: 'clip' }}
                              className="zeal-product-slide"
                            >
                              <CardMedia
                                component="img"
                                className="main-img"
                                src={
                                  selectedImage
                                    ? // eslint-disable-next-line react-hooks/rules-of-hooks
                                      useCloudinary(selectedImage, 'w_800,q_auto,f_auto')
                                    : '/assets/car.png'
                                }
                                alt="Main Vehicle"
                                sx={{
                                  width: '100%',
                                  // height: isMobile ? 250 : 500,
                                  objectFit: 'cover',
                                  borderRadius: '16px',
                                  aspectRatio: '799 / 506',
                                }}
                                onLoad={() => setImgLoading(false)}
                                onError={() => setImgLoading(false)}
                              />
                              <IconButton
                                // onClick={() => navigate(-1)}
                                onClick={() => {
                                  navigate(-1);
                                  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                }}
                                sx={{
                                  position: 'absolute',
                                  top: 16,
                                  left: 10,
                                  color: '#ffffff',
                                  backgroundColor: '#00000099',
                                  '&:hover': {
                                    backgroundColor: 'rgba(#837c69,0.9)',
                                  },
                                  zIndex: 2,
                                }}
                              >
                                <ArrowBack sx={{ height: '25px' }} />
                              </IconButton>
                            </Box>
                          )}
                        </Card>

                        {/* Thumbnails */}
                        <Slider {...thumbnailSettings}>
                          {loading ? (
                            // Show 5 skeleton thumbnails while loading
                            Array.from(new Array(5)).map((_, idx) => (
                              <Stack key={idx} px={0.5}>
                                <Skeleton
                                  variant="rectangular"
                                  width={120}
                                  height={80}
                                  sx={{
                                    borderRadius: '8px',
                                    bgcolor: '#1e1e1e',
                                  }}
                                />
                              </Stack>
                            ))
                          ) : vehicleDetails?.images?.length === 0 ? (
                            <Stack key="default-image" className="related-prod">
                              <Card>
                                <CardMedia
                                  component="img"
                                  src="/assets/car.png"
                                  alt="Default Thumbnail"
                                  sx={{
                                    width: 120,
                                    height: 80,
                                    cursor: 'pointer',
                                    borderRadius: '8px',
                                    boxShadow: 'unset',
                                    backgroundColor: '#121212',
                                  }}
                                />
                              </Card>
                            </Stack>
                          ) : (
                            vehicleDetails.images?.map((item, key) => (
                              <Stack key={key} px={0.5}>
                                <Card
                                  onClick={() => setSelectedImage(item?.url)}
                                  sx={{
                                    cursor: 'pointer',
                                    borderRadius: 1,
                                    backgroundColor: '#121212',
                                    boxShadow: 'unset',
                                  }}
                                >
                                  <CardMedia
                                    component="img"
                                    // eslint-disable-next-line react-hooks/rules-of-hooks
                                    src={item?.url ? useCloudinary(item.url, 'w_300') : '/assets/car.png'}
                                    alt="Thumbnail"
                                    sx={{
                                      width: '100%',
                                      height: 80,
                                      objectFit: 'cover',
                                      borderRadius: 0.5,
                                    }}
                                  />
                                </Card>
                              </Stack>
                            ))
                          )}
                        </Slider>
                      </Box>
                      <div className="">
                        <div className="w-100">
                          {!isMobile && (
                            <Grid
                              item
                              xs={12}
                              md={6}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              mt={0}
                              zIndex={1}
                              sx={{
                                width: '100%',
                              }}
                            >
                              <Stack direction="row" width="100%" gap={2}>
                                <Stack width="65%">
                                  <Button
                                    type="submit"
                                    variant="contained"
                                    className="request-btn"
                                    sx={{
                                      height: '82%',
                                      mt: 1.4,
                                      px: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      color: 'black !important',
                                      backgroundColor: '#f06f1a !important',
                                      borderRadius: '10px',
                                      textTransform: 'none',
                                      boxShadow: 'unset !important',
                                      overflow: 'hidden',
                                    }}
                                    onClick={() => setOpenLeadModal(true)}
                                  >
                                    <span style={{ fontSize: 18, fontWeight: 500, color: '#212121' }}>
                                      Book a Test Drive!
                                    </span>
                                  </Button>
                                </Stack>
                                <Stack width="45%">
                                  <a href="https://wa.me/918590889853" target="_blank" rel="noopener noreferrer">
                                    <Box
                                      component="img"
                                      src="/assets/images/Product/contactWhatsappBlack.png"
                                      alt="Whatsapp"
                                      sx={{
                                        width: '100%',
                                        objectFit: 'cover',
                                        display: 'block',
                                        borderRadius: 0,
                                        cursor: 'pointer',
                                      }}
                                    />
                                  </a>
                                </Stack>
                              </Stack>
                            </Grid>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </Stack>
                <Stack
                  ref={leftRef}
                  sx={{
                    ...(!isMobile && {
                      width: '35%',
                      overflowY: 'auto',

                      // so right side also scrolls within viewport if content is long
                    }),
                  }}
                >
                  <Stack
                    px={1}
                    sx={{
                      pt: 5,

                      '@media (max-width:400px)': {
                        pt: 3,
                      },
                      '@media (max-width:365px)': {
                        pt: 2,
                      },
                    }}
                  >
                    <Typography color={'#FFFFFFDE'} fontSize={20} fontWeight={600}>
                      {vehicleDetails?.name}
                    </Typography>
                    <Typography color={'#FFFFFFDE'} fontSize={16} fontWeight={500}>
                      {vehicleDetails?.variant?.name}
                    </Typography>
                  </Stack>
                  <Grid container direction="row" spacing={1} mt={1}>
                    {/* brand */}
                    <Grid item xs={4} md={4} lg={4} mb={1}>
                      <Card
                        sx={{
                          backgroundColor: '#202020',
                          boxShadow: 'none',
                          minHeight: '69px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          {vehicleDetails && vehicleDetails?.brand && vehicleDetails?.brand?.logo && (
                            <img
                              src={vehicleDetails?.brand?.logo[0]?.url || NoImage}
                              alt=""
                              width={'55px'}
                              height={'50px'}
                              style={{ objectFit: 'contain' }}
                            />
                          )}
                          {/* <Typography fontSize={10} fontWeight={400} color={'#FFFFFFDE'} pt={1}>
                          {vehicleDetails?.brand?.name || '---'}
                        </Typography> */}
                        </Box>
                      </Card>
                    </Grid>
                    {/* fuel */}

                    <Grid item xs={4} md={4} lg={4} mb={1}>
                      <Card
                        sx={{
                          backgroundColor: '#202020',
                          boxShadow: 'none',
                          minHeight: '69px',
                        }}
                      >
                        <Grid
                          sx={{ backgroundColor: '#292929', py: 0.8 }}
                          display={'flex'}
                          justifyContent={'center'}
                          alignItems={'center'}
                        >
                          <Stack>
                            <img src="/assets/images/Home/fuel.png" alt="" style={{ width: '16px', height: '16px' }} />
                          </Stack>
                        </Grid>
                        <Stack>
                          <Typography fontSize={18} fontWeight={400} color={'#E3E3E3'} textAlign={'center'} pt={1}>
                            {/* {capitalizeFirstLetter(vehicleDetails?.fuelType)} */}
                            {vehicleDetails?.fuelType ? capitalizeFirstLetter(vehicleDetails.fuelType) : '---'}
                          </Typography>
                        </Stack>
                      </Card>
                    </Grid>
                    {/* year */}

                    <Grid item xs={4} md={4} lg={4} mb={1}>
                      <Card
                        sx={{
                          backgroundColor: '#202020',
                          boxShadow: 'none',
                          minHeight: '69px',
                        }}
                      >
                        <Grid sx={{ backgroundColor: '#292929', width: '100%' }}>
                          <Typography color={'#FFA800'} fontSize={10} fontWeight={400} textAlign={'center'} py={1}>
                            Purchase Year
                          </Typography>
                        </Grid>
                        <Grid sx={{ width: '100%' }}>
                          <Typography color={'#E3E3E3'} fontSize={18} fontWeight={200} textAlign={'center'} pt={1}>
                            {vehicleDetails?.makeYear || '---'}
                          </Typography>
                        </Grid>
                      </Card>
                    </Grid>

                    {/* kilometer */}
                    {/* {isMobile && ( */}
                    <Grid item xs={6} md={6} lg={6} mb={1}>
                      <Card
                        sx={{
                          backgroundColor: '#202020',
                          boxShadow: 'none',
                          minHeight: '76px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Stack>
                          <Box display={'flex'} alignItems={'center'}>
                            <img src="/assets/images/Home/km.png" style={{ width: '39px', height: '34px' }} alt="" />
                            <Stack ml={1}>
                              <Typography fontSize={10} fontWeight={400} color={'#FFA800'}>
                                Kilometers
                              </Typography>
                              <Typography fontSize={18} fontWeight={400} color={'#E3E3E3'}>
                                {vehicleDetails?.kiloMeter || '---'}
                              </Typography>
                            </Stack>
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>
                    {/* )} */}
                    {/* {!isMobile && (
                    <>
                      <Grid item xs={6} mb={1}>
                        <Card
                          sx={{
                            backgroundColor: '#202020',
                            boxShadow: 'none',
                            minHeight: '100px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Stack>
                            <Box display={'flex'} alignItems={'center'}>
                              <img src="/assets/images/Home/km.png" style={{ width: '39px', height: '34px' }} alt="" />
                              <Stack ml={2}>
                                <Typography fontSize={12} fontWeight={400} color={'#FFA800'}>
                                  Kilometers Driven
                                </Typography>
                                <Typography fontSize={18} fontWeight={400} color={'#E3E3E3'}>
                                  {vehicleDetails?.kiloMeter} Kms
                                </Typography>
                              </Stack>
                            </Box>
                          </Stack>
                        </Card>
                      </Grid>
                    </>
                  )} */}

                    {/* Ownership */}
                    <Grid item xs={6} md={6} lg={6} mb={1}>
                      <Card
                        sx={{
                          backgroundColor: '#202020',
                          boxShadow: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          minHeight: '76px',
                        }}
                      >
                        <Stack>
                          <Box display={'flex'} alignItems={'center'}>
                            <img
                              src="/assets/images/Home/ownership.png"
                              style={{ width: '39px', height: '34px' }}
                              alt=""
                            />
                            <Stack ml={1}>
                              <Typography fontSize={10} fontWeight={400} color={'#FFA800'}>
                                Ownership
                              </Typography>
                              <Typography fontSize={18} fontWeight={400} color={'#E3E3E3'}>
                                {vehicleDetails?.ownershipStatus
                                  ? handleOwnershipStatus(vehicleDetails.ownershipStatus)
                                  : '---'}{' '}
                              </Typography>
                            </Stack>
                          </Box>
                        </Stack>
                      </Card>
                    </Grid>

                    {/* <Grid item xs={12} md={7} lg={7} mb={3}>
                <Card
                  className="location-box-web"
                  sx={{
                    backgroundColor: '#202020',
                    boxShadow: 'none',
                    minHeight: isMobile ? 150 : 100,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Grid
                    sx={{ width: '50%', minHeight: isMobile ? 150 : '120px', maxHeight: isMobile ? '' : 50 }}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                  >
                    <Stack>
                      <Typography fontSize={12} fontWeight={400} color={'#FFA800'}>
                        Showroom
                      </Typography>
                      <Typography fontSize={20} fontWeight={400} color={'white'}>
                        Pandikkad
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid sx={{ width: '50%', minHeight: '150px' }}>
                    <img src="/assets/images/Home/map.png" style={{ width: '100%' }} alt="" />
                  </Grid>
                </Card>
              </Grid> */}
                  </Grid>
                  {/* {vehicleDetails?.tags?.length > 0 && (
              <Typography color={'#F8971C'} fontSize={15} fontWeight={700}>
                More Features
              </Typography>
            )} */}
                  {vehicleDetails?.price > 0 && (
                    <Typography py={2}>
                      <Box component="span" sx={{ color: '#FFFFFF99', fontWeight: 500, fontSize: '15px', mr: 0.5 }}>
                        Price:
                      </Box>
                      <Box component="span" sx={{ color: '#FFFFFFDE', fontWeight: 600, fontSize: '16px' }}>
                        {new Intl.NumberFormat('en-IN', {
                          style: 'currency',
                          currency: 'INR',
                          maximumFractionDigits: 0,
                        }).format(vehicleDetails?.price || 0)}
                      </Box>
                    </Typography>
                  )}
                  {vehicleDetails?.price > 0 && vehicleDetails?.max_available_loan > 0 && (
                    <EmiBox
                      mt={!vehicleDetails?.price && '2'}
                      LoanPercentage={vehicleDetails?.max_available_loan || 0}
                      productPrice={vehicleDetails?.price || 0}
                    />
                  )}
                  {!isMobile && (
                    <>
                      <Grid
                        container
                        direction="row"
                        mb={3}
                        mt={2}
                        px={2}
                        pb={2}
                        sx={{
                          borderBottom: '1px solid',
                          borderImageSource: 'linear-gradient(90deg, #333333 0%, #9E9E9E 49.07%, #333333 100%)',
                          borderImageSlice: 1,
                        }}
                      >
                        {vehicleDetails?.tags?.map((item, key) => (
                          <Grid item xs={12} md={12} lg={12} display={'flex'} alignItems={'center'} mt={1} key={key}>
                            <Stack position={'relative'}>
                              {/* <Box
                    sx={{
                      borderRadius: '50%',
                      backgroundColor: '#202020',
                      width: '25px',
                      height: '25px',
                      boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.7)',
                    }}
                  /> */}
                              <DoneIcon style={{ color: '#F6851F' }} fontSize="small" />
                            </Stack>
                            <Typography color={'#FFFFFF99'} fontSize={14} pl={1}>
                              {item}
                            </Typography>
                          </Grid>
                        ))}
                      </Grid>
                      {vehicleDetails?.description && (
                        <Stack className={`${!isMobile && ''}`} mb={!isMobile && 3}>
                          <Typography color={'#FFFFFF99'} fontSize={16} fontWeight={700}>
                            More Details
                          </Typography>
                          <Typography
                            fontSize={14}
                            color={'#FFFFFF99'}
                            fontWeight={300}
                            pt={1}
                            sx={{ whiteSpace: 'pre-line' }}
                          >
                            {vehicleDetails?.description}
                          </Typography>
                        </Stack>
                      )}
                      {vehicleDetails?.youtube_id && (
                        <ProductSingleYoutubeShort youtubeId={vehicleDetails?.youtube_id} />
                      )}
                    </>
                  )}
                </Stack>
              </Stack>
            </Container>

            {/* {vehicleDetails?.tags?.length > 0 && <div className="prod-div-home" />} */}
            {isMobile ? (
              <>
                <Grid
                  container
                  direction="row"
                  mb={3}
                  mt={2}
                  px={2}
                  pb={2}
                  sx={{
                    borderBottom: '1px solid',
                    borderImageSource: 'linear-gradient(90deg, #333333 0%, #9E9E9E 49.07%, #333333 100%)',
                    borderImageSlice: 1,
                  }}
                >
                  {vehicleDetails?.tags?.map((item, key) => (
                    <Grid item xs={12} md={3} lg={3} display={'flex'} alignItems={'center'} mt={1} key={key}>
                      <Stack position={'relative'}>
                        {/* <Box
                    sx={{
                      borderRadius: '50%',
                      backgroundColor: '#202020',
                      width: '25px',
                      height: '25px',
                      boxShadow: '10px 10px 10px rgba(0, 0, 0, 0.7)',
                    }}
                  /> */}
                        <DoneIcon style={{ color: '#F6851F' }} fontSize="small" />
                      </Stack>
                      <Typography color={'#FFFFFF99'} fontSize={14} pl={1}>
                        {item}
                      </Typography>
                    </Grid>
                  ))}
                </Grid>
                <Container maxWidth="lg" sx={{ padding: isMobile ? '0px 18px 50px 18px' : '0px 18px 100px 18px' }}>
                  {vehicleDetails?.description && (
                    <Stack className={`${!isMobile && ''}`} mb={isMobile ? 2 : 5}>
                      <Typography color={'#FFFFFF99'} fontSize={16} fontWeight={700}>
                        More Details
                      </Typography>
                      <Typography
                        fontSize={14}
                        color={'#FFFFFF99'}
                        fontWeight={300}
                        pt={1}
                        sx={{ whiteSpace: 'pre-line' }}
                      >
                        {vehicleDetails?.description}
                      </Typography>
                    </Stack>
                  )}

                  {vehicleDetails?.youtube_id && <ProductSingleYoutubeShort youtubeId={vehicleDetails?.youtube_id} />}

                  {/* <Stack my={4}>
                    <Youtube />
                  </Stack> */}

                  {isMobile && (
                    // <Grid
                    //   display={'flex'}
                    //   my={10}
                    //   position={'fixed'}
                    //   bottom={60}
                    //   zIndex={1}
                    //   width={'90%'}
                    //   className={`floating-card ${scrollValue >= 290 ? 'active' : ''}`}
                    // >
                    //   <Box
                    //     width={'35%'}
                    //     // mr={1}
                    //     sx={{
                    //       borderTopLeftRadius: '10px',
                    //       borderBottomLeftRadius: '10px',
                    //       // borderRadius: '10px',
                    //       // aspectRatio: 4 / 3,
                    //       // height: '65px',
                    //     }}
                    //   >
                    //     {vehicleDetails && vehicleDetails?.images && (
                    //       <img
                    //         src={
                    //           vehicleDetails?.images[0]?.url
                    //             ? // eslint-disable-next-line react-hooks/rules-of-hooks
                    //               useCloudinary(vehicleDetails?.images[0]?.url, 'w_500')
                    //             : image[0]?.img
                    //         }
                    //         alt=""
                    //         style={{
                    //           width: '100%',
                    //           borderTopLeftRadius: '10px',
                    //           borderBottomLeftRadius: '10px',
                    //           objectFit: 'cover',
                    //           height: '100%',
                    //           // borderRadius: '10px',
                    //           aspectRatio: 4 / 3,
                    //           // border: '#f8971c 1.5px solid',
                    //         }}
                    //       />
                    //     )}
                    //   </Box>
                    //   <CustomButton
                    //     type="submit"
                    //     variant="contained"
                    //     className="request-btn"
                    //     sx={{
                    //       flexDirection: 'column',
                    //       width: '100%',
                    //       px: 2,
                    //     }}
                    //     onClick={() => setOpenLeadModal(true)}
                    //   >
                    //     <span style={{ fontSize: 18, fontWeight: 900 }}> Get Price & Test Drive!</span>
                    //     <span style={{ fontSize: 11 }}> Our car guide will give you a call</span>
                    //   </CustomButton>
                    // </Grid>
                    <Grid
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      // my={10}
                      position="fixed"
                      zIndex={1}
                      width="92%"
                      height="65px"
                      className={`floating-card ${scrollValue >= 250 ? 'active' : ''}`}
                    >
                      {/* Image Box with Sloped Edge */}
                      <Box
                        width="30%"
                        height="100%"
                        position="relative"
                        sx={{
                          borderTopLeftRadius: '10px',
                          boxShadow: '0 10px 10px rgba(0, 0, 0, 0.9)',

                          borderBottomLeftRadius: '10px',
                          overflow: 'hidden',
                          '::after': {
                            content: '""',
                            position: 'absolute',
                            right: '-1px',
                            top: 0,
                            width: '20px',
                            height: '100%',
                            backgroundColor: '#f06f1a',
                            clipPath: 'polygon(100% 0, 100% 100%, 0% 100%)',
                            zIndex: 2,
                          },
                        }}
                      >
                        {vehicleDetails && vehicleDetails?.images && (
                          <img
                            src={
                              vehicleDetails?.images[0]?.url
                                ? // eslint-disable-next-line react-hooks/rules-of-hooks
                                  useCloudinary(vehicleDetails?.images[0]?.url, 'w_400,q_auto,f_auto')
                                : image[0]?.img
                            }
                            alt=""
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        )}
                      </Box>

                      {/* Button */}
                      <CustomButton
                        type="submit"
                        variant="contained"
                        className="request-btn"
                        sx={{
                          width: '70%',
                          height: '100%',
                          px: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          color: 'black !important',
                          backgroundColor: '#f06f1a !important',
                          borderTopRightRadius: '10px',
                          borderBottomRightRadius: '10px',
                          textTransform: 'none',
                          overflow: 'hidden',
                        }}
                        onClick={() => setOpenLeadModal(true)}
                      >
                        <Box sx={{ lineHeight: 1.2 }}>
                          <span style={{ fontSize: 18, fontWeight: 700 }}>Book a FREE Test Drive</span>
                          <br />
                          <span style={{ fontSize: 12, fontWeight: '400' }}>Our Car Guide Will Give You A Call</span>
                        </Box>
                      </CustomButton>
                    </Grid>
                  )}
                  <Stack>
                    {isMobile && (
                      <>
                        <Button
                          onClick={() => setOpenLeadModal(true)}
                          sx={{
                            color: 'black',
                            backgroundColor: '#f06f1a',
                            width: '100%',
                            height: '48px',
                            borderRadius: ' 10px',
                            fontSize: '18px',
                            marginTop: '15px',

                            mb: 2,
                            '&:hover': {
                              backgroundColor: '#d95f12',
                            },
                          }}
                        >
                          Book a Test Drive For Free
                        </Button>
                        <a href="https://wa.me/918590889853" target="_blank" rel="noopener noreferrer">
                          <Box
                            component="img"
                            src="/assets/images/Product/contactWhatsappBlack.png"
                            alt="Whatsapp"
                            sx={{
                              width: '100%',
                              // marginBottom: '59px',
                              objectFit: 'cover',
                              display: 'block',
                              borderRadius: 0,
                              cursor: 'pointer', // show pointer on hover
                            }}
                          />
                        </a>
                        {relatedVehicles?.relatedVehicles?.length > 0 && (
                          <>
                            <Typography color={'#FFFFFFDE'} fontSize={15} fontWeight={700} pt={5} pb={2}>
                              Related Cars
                            </Typography>
                            <Box className={relatedVehicles?.relatedVehicles?.length === 1 ? 'left-align-slick' : ''}>
                              <Slider {...carouselSettings}>
                                {relatedVehicles?.relatedVehicles?.map((related, key) => (
                                  <Stack key={key} className="related-prod">
                                    <ProductCard product={related} />
                                  </Stack>
                                ))}
                              </Slider>
                            </Box>
                          </>
                        )}
                      </>
                    )}
                  </Stack>
                  {/* public/assets/images/Product/contactWhatsapp.png */}
                </Container>
              </>
            ) : (
              <>
                <Container maxWidth="md">
                  {/* {vehicleDetails?.youtube_id && <ProductSingleYoutube youtubeId={vehicleDetails?.youtube_id} />} */}
                  {/* <Grid container mt={11} columnSpacing={2}>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      // my={10}
                      mt={2.4}
                      zIndex={1}
                      sx={{
                        width: '100%',
                        height: '80px',
                      }}
                    >
                 
                      <Box
                        width="30%"
                        height="100%"
                        position="relative"
                        sx={{
                          borderTopLeftRadius: '10px',

                          borderBottomLeftRadius: '10px',
                          overflow: 'hidden',
                          '::after': {
                            content: '""',
                            position: 'absolute',
                            right: '-1px',
                            top: 0,
                            width: '20px',
                            height: '100%',
                            backgroundColor: '#f06f1a',
                            clipPath: 'polygon(100% 0, 100% 100%, 0% 100%)',
                            zIndex: 2,
                          },
                        }}
                      >
                        {vehicleDetails && vehicleDetails?.images && (
                          <img
                            src={
                              vehicleDetails?.images[0]?.url
                                ? // eslint-disable-next-line react-hooks/rules-of-hooks
                                  useCloudinary(vehicleDetails?.images[0]?.url, 'w_400,q_auto,f_auto')
                                : image[0]?.img
                            }
                            alt=""
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        )}
                      </Box>

                      <CustomButton
                        type="submit"
                        variant="contained"
                        className="request-btn"
                        sx={{
                          width: '70%',
                          height: '100%',
                          px: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          color: 'black !important',
                          backgroundColor: '#f06f1a !important',
                          borderTopRightRadius: '10px',
                          borderBottomRightRadius: '10px',
                          textTransform: 'none',
                          boxShadow: 'unset !important',
                          overflow: 'hidden',
                        }}
                        onClick={() => setOpenLeadModal(true)}
                      >
                        <Box sx={{ lineHeight: 1.2 }}>
                          <span style={{ fontSize: 18, fontWeight: 700 }}>Book a FREE Test Drive</span>
                          <br />
                          <span style={{ fontSize: 12, fontWeight: '400' }}>Our Car Guide Will Give You A Call</span>
                        </Box>
                      </CustomButton>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <a href="https://wa.me/918590889853" target="_blank" rel="noopener noreferrer">
                        <Box
                          component="img"
                          src="/assets/images/Product/contactWhatsapp.png"
                          alt="Whatsapp"
                          sx={{
                            width: '100%',
                            marginBottom: '59px',
                            objectFit: 'cover',
                            display: 'block',
                            borderRadius: 0,
                            cursor: 'pointer', // show pointer on hover
                          }}
                        />
                      </a>
                    </Grid>
                  </Grid> */}
                </Container>
                {relatedVehicles?.relatedVehicles?.length > 0 && (
                  <Stack mt={2} mb={8}>
                    <Typography color={'#FFFFFFDE'} fontSize={25} fontWeight={700} pt={5} pb={2}>
                      Related Cars
                    </Typography>
                    <Box className={relatedVehicles?.relatedVehicles?.length === 1 ? 'left-align-slick' : ''}>
                      <Slider {...carouselSettings}>
                        {relatedVehicles?.relatedVehicles?.map((related, key) => (
                          <Stack key={key} className="related-prod">
                            <ProductCard product={related} />
                          </Stack>
                        ))}
                      </Slider>
                    </Box>
                  </Stack>
                )}
              </>
            )}
          </Box>
        </>
      )}
      <Stack>
        <CarDeliverySection carDeliveryList={carDeliveryList?.list} productSingle="productSingle" />
      </Stack>
      <Stack mb={isMobile ? 0 : 8}>
        {youtubeVideosList?.list?.length > 0 && (
          <YoutubeCarousel youtubeVideosList={youtubeVideosList?.list} productSingle="productSingle" />
        )}
      </Stack>
    </>
  );
}
